import {
    Dialog,
    DialogContent,
    Button,
    IconButton,
    Typography,
    AppBar,
    Stack,
    Box,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Tooltip,
    Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomTitle, Loader, getCorporationLabel, getFilteredData } from "../HelperFunctions/HelperFunctions";
import { useEffect, useMemo, useState } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { enqueueSnackbar } from "notistack";
import { useLoaderData } from "react-router-dom";
import { getCorporationsByMgntGrp } from "../API/nimbleAPI";

const FlashReportCorpDialog = ({ open, onClose, formik, managementGroups, corpCount }) => {


    const { UID, clientName, token } = useLoaderData()
    const [loading, setLoading] = useState(false);

    const [corpTableData, setCorpTableData] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    const [selectedCorporations, setSelectedCorporations] = useState([]);

    const [selectedManagementGroup, setSelectedManagementGroup] = useState({});

    const [searchTerm, setSearchTerm] = useState("");
    const [corporationCount, setCorporationCount] = useState(false);

    useEffect(() => {
        if (open) {
            setSelectedCorporations(formik.values.details.corporation || []);
            setSelectedManagementGroup(formik.values.details.management_groups || {});
        }
    }, [open]);


    useEffect(() => {
        if (selectedManagementGroup?.ValueCode) {
            fetchCorporationData(selectedManagementGroup.ValueCode);
        }
    }, [selectedManagementGroup]);





    const columns = [
        { name: "corporation_name_DBA_name", dataKey: "CorporationName", width: "120px" },
        { name: "legal_name", dataKey: "LegalName", width: "120px" },
        { name: "property_type", dataKey: "PropertyType", width: "110px" },
        { name: "service", dataKey: "Service", width: "110px" },
        { name: "brand", dataKey: "Brand", width: "65px" },
        { name: "pms", dataKey: "PMS", width: "80px" },
    ];

    const fetchCorporationData = async (valueCode) => {
        setLoading(true);
        try {
            const data = await getCorporationsByMgntGrp(valueCode);
            setCorpTableData(data);
            setOriginalData(data);
            const corporationIds = await data.map(item => item.CorporationID);
            setCorporationCount(corporationIds?.length)
            corpCount(corporationIds?.length)
        } catch (error) {
            enqueueSnackbar("Error while getting Corporations", { variant: "error" })
        } finally {
            setLoading(false);
        }


    };

    const handleSelectAll = (checked) => {
        if (checked) {
            const allIds = corpTableData.map((row) => row.CorporationID);
            setSelectedCorporations(allIds);
        } else {
            setSelectedCorporations([]);
        }
    };
    const handleSelectOne = (checked, id) => {
        if (checked) {
            setSelectedCorporations([...selectedCorporations, id]);
        } else {
            setSelectedCorporations(selectedCorporations.filter((item) => item !== id));
        }
    };

    const handleApply = () => {
        formik.setFieldValue("details.corporation", selectedCorporations);
        formik.setFieldValue("details.management_groups", selectedManagementGroup);

        onClose();
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
        const filtered = getFilteredData(value, originalData);
        setCorpTableData(filtered);
    };




    const TableComponents = {
        Table: (props) => (
            <Table
                {...props}
                style={{
                    borderCollapse: "separate",
                    tableLayout: "fixed",
                }}
            />
        ),
        TableHead,
        TableRow,
        TableBody,
    };

    const fixedHeaderContent = () => (
        <TableRow sx={{ bgcolor: "#d7d7d7" }}>
            <TableCell
                // width="1px"
                // sx={{ padding: "1px", borderRight: "1px solid white" }}
                width="40px"
                sx={{
                    padding: "1px",
                    borderRight: "1px solid white",
                    minWidth: "30px",
                    maxWidth: "30px",
                }}
            >
                {/* <Checkbox size="small" color="grey" disableRipple /> */}
                <Checkbox
                    size="small"
                    color="grey"
                    // checked={selectedCorporations.length === corpTableData.length}
                    checked={selectedCorporations.length > 0 &&
                        selectedCorporations.length === corpTableData.length}
                    indeterminate={
                        selectedCorporations.length > 0 &&
                        selectedCorporations.length < corpTableData.length
                    }
                    onChange={(e) => handleSelectAll(e.target.checked)}
                />
            </TableCell>
            {columns.map((column, index) => (
                <TableCell
                    key={index}
                    width={column.width}
                    sx={{
                        borderRight: "1px solid white",
                        padding: 1,
                        fontSize: "13px",
                        fontWeight: 500,
                    }}
                >
                    {column.name === "pms" ? "PMS" : CustomTitle(column.name)}
                </TableCell>
            ))}
        </TableRow>
    );

    const itemContent = (index) => {
        const row = corpTableData[index];
        return (
            <>
                <TableCell sx={{ padding: "1px", borderRight: "1px solid #f2f2f2" }}>

                    <Checkbox
                        size="small"
                        color="grey"
                        checked={selectedCorporations.includes(row.CorporationID)}
                        onChange={(e) => handleSelectOne(e.target.checked, row.CorporationID)}
                    />
                </TableCell>
                {columns.slice(0, 7).map((column, colIndex) => (
                    <TableCell
                        key={colIndex}
                        sx={{
                            borderRight: "1px solid #f2f2f2",
                            padding: "10px",
                            fontSize: "12px",
                            maxWidth: column.width,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        <Tooltip title={row[column.dataKey] || "-"} arrow>
                            <span>{row[column.dataKey] || "-"}</span>
                        </Tooltip>
                    </TableCell>
                ))}
            </>
        );
    };

    return (
        <Dialog open={open} fullScreen>
            <AppBar
                sx={{ position: "relative", bgcolor: "#d7d7d7", height: 45 }}
                elevation={0}
            >
                <Box sx={{ height: 45, alignContent: "center", padding: "0 15px" }}>
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                    >
                        <Stack direction={"row"}>
                            <IconButton
                                size="small"
                                edge="start"
                                color="inherit"
                                onClick={onClose}
                                aria-label="close"
                                style={{ backgroundColor: "#686868" }}
                                disableRipple
                            >
                                <CloseIcon sx={{ fontSize: "15px" }} />
                            </IconButton>
                            <Typography
                                sx={{
                                    ml: 2,
                                    flexGrow: 10,
                                    color: "#1f1f1f",
                                }}
                                component="div"
                                fontWeight={600}
                                fontSize={"15px"}
                            >
                                Corporation Selection
                            </Typography>
                        </Stack>
                        <Stack direction={"row"} gap={3}>
                            <Button
                                variant="contained"
                                size="small"
                                disableElevation
                                disableRipple
                                sx={{
                                    px: 4,
                                    textTransform: "none",
                                    backgroundColor: "#b5dcf2",
                                    color: "#000",
                                    fontWeight: 400,
                                }}
                                onClick={handleApply}
                            >
                                Apply
                            </Button>
                        </Stack>
                    </Stack>
                </Box>
            </AppBar>
            <DialogContent
                sx={{
                    padding: 1,
                }}
            >
                <Stack gap={2} height={"630px"} direction={"column"}>
                    <Stack direction={"row"} gap={2}>

                        <Autocomplete
                            size="small"
                            sx={{ minWidth: 250, maxWidth: 250, m: 1 }}
                            options={managementGroups}
                            getOptionLabel={(option) => option.DisplayText || ""}
                            isOptionEqualToValue={(option, value) => option?.ValueCode === value?.ValueCode}
                            value={
                                selectedManagementGroup?.ValueCode === "ALL"
                                    ? { ValueCode: "ALL", DisplayText: "--ALL--" }
                                    : selectedManagementGroup || null
                            }
                            disableClearable
                            onChange={(event, newValue) => {
                                if (
                                    newValue &&
                                    ["PropertyType", "BrandName", "Portfolio", "Region", "ServiceType"].includes(newValue.ValueCode)
                                ) {
                                    setSelectedManagementGroup({
                                        ValueCode: "ALL",
                                        DisplayText: "--ALL--",
                                    });
                                    // fetchCorporationData("ALL")
                                } else {
                                    setSelectedManagementGroup(newValue);
                                }
                                setSelectedCorporations([]);
                                setSearchTerm("");
                                setCorporationCount(false)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Management Groups"
                                    inputProps={{ ...params.inputProps, readOnly: true }}
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: { fontSize: "13px", fontWeight: 500 },
                                    }}
                                    InputLabelProps={{
                                        sx: { fontSize: "12px" },
                                    }}
                                />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option.ValueCode} style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {option.DisplayText}
                                </li>
                            )}
                        />


                        <TextField
                            sx={{
                                mt: 1,
                                minWidth: 220,
                                backgroundColor: "transparent",
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "transparent",
                                    maxHeight: "33px",
                                    fontSize: "13px",
                                    bgcolor: "#f5f5f5",
                                    fontWeight: 500,
                                },
                            }}
                            size="small"
                            label="Corporation"
                            name="details.corporation"
                            value={
                                selectedCorporations.length === corporationCount && corporationCount > 0 ? "All_corporation(s)selected"
                                    :
                                    selectedCorporations.length > 9
                                        ? `${selectedCorporations.length}_corporation(s)selected`
                                        : selectedCorporations.length > 0
                                            ? `0${selectedCorporations.length}_corporation(s)selected`
                                            : "00_corporation(s)selected"
                            }

                            // value={getCorporationLabel(selectedCorporations.length, corporationCount)}
                            InputProps={{ readOnly: true }}
                        />

                        <TextField
                            size='small'
                            placeholder='Search'
                            sx={{
                                mt: 1,
                                minWidth: 300,
                                backgroundColor: "transparent",
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "transparent",
                                    maxHeight: "33px",
                                    fontSize: "13px",
                                    bgcolor: "#f5f5f5",
                                    fontWeight: 500,
                                },
                            }}
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </Stack>

                    <Box
                        height={"100%"}
                        border={"1px solid #d7d7d7"}
                    // overflow={"auto"}
                    >
                        <TableVirtuoso
                            style={{ height: "570px" }}
                            data={corpTableData}
                            components={TableComponents}
                            fixedHeaderContent={fixedHeaderContent}
                            itemContent={itemContent}
                        />
                    </Box>
                </Stack>
            </DialogContent>
            <Loader loading={loading} />
        </Dialog>
    );
};

export default FlashReportCorpDialog;
